let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5a4qf")).then(() => parcelRequire('gl9mP'));